import {useEffect, useState} from "react";
import axios from "axios";
import {BaseURL} from "../constants/Constants";
import {useNavigate, useParams} from "react-router";
import {ActionButton} from "../components/ActionButton";
import {Button, Spinner} from "@nextui-org/react";

export const TicketList = () => {
    const history = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { ticket_code } = useParams();
    const [receivedData, setReceivedData] = useState({});
    const [tickets, setTickets] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${BaseURL}/events/tickets/list/${ticket_code}/`).then(
            res => {
                setIsLoading(false);
                console.log(res.data);
                setReceivedData(res.data);
                setTickets(res.data.tickets);
            }
        ).catch(
            e => {
                history("/");
                console.log(e.response.data.message);
            }
        )
    }, []);

    if(!isLoading){
        return(
            <div className={"max-w-[400px] m-auto p-[12px] overflow-auto relative"}>
                <div className={"rounded-[6px] border-[#5A5655] border-[1px] bg-[#323232] mb-[40px] p-[8px] z-50"}>
                    <Button type={"submit"}
                            disabled={false}
                            fullWidth={true}
                            className={"rounded-md bg-[#FCE345]" +
                                " text-[14px] font-bold text-[black]" +
                                " border-[1px] border-[#5E5E5E]" +
                                " flex justify-between text-center w-full"}
                            onClick={() => {history("/scanner")}}><p className={"text-center w-full"}>
                        Вернуться к сканеру
                    </p></Button>
                </div>
                <div className={"w-full flex flex-col gap-[16px]"}>
                    {
                        tickets.map((ticket, index) => (
                            <div key={index} className={`rounded-[6px] border-[1px] bg-[#323232] p-[8px] flex gap-[16px] flex-col "border-[#5E5E5E]"`}>
                                <p className={"text-white text-bold font-bold text-[22px]"}>{ticket.tariff}</p>
                                <p className={"text-white text-bold text-[18px]"}>Номер билета: <p className={"font-bold"}>{ticket.code}, {ticket.comment}</p></p>
                                <p className={"text-white text-bold font-bold text-[12px]"}>{ticket.event_name}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }
    return(
        <div className={"max-w-[400px] m-auto p-[12px]"}>

        </div>
    )
}
